<template>
    <div class="page-vms-introduce">
        <div class="introduce-top-bg">
        <div class="introduce-top-wrap">
          <div class="introduce-main-box">
            <div class="top-tit">
              <h2>丰富资源+专业服务</h2>
              <p class="txt1">找到合适的供应商资源，派单给专业猎头</p>
              <p class="txt1">高端职位不再难招</p>
              <p class="txt2">适用于<strong>猎头职位</strong></p>
              <a href="javascript://" @click="unloginBuyServicePop = true">点击购买</a>
            </div>
            <div class="top-mac">

            </div>
          </div>
        </div>
        <div class="introduce-top-wrap-bg">

        </div>
        </div>
        <div style="width:100%;background:#fff;">
          <div class="introduce-core introduce-main-box">
            <h3><strong>供应商管理</strong>的核心价值</h3>
            <ul>
              <li><span>1</span>智能化、精细化 调度猎企与猎头做职位</li>
              <li><span>2</span>智能化、动态化 检验猎企与猎头的服务过程</li>
              <li><span>3</span>智能化、标准化 定制猎企与猎头的服务标准</li>
              <li><span>4</span>智能化、灵活化 的与现有系统兼容</li>
            </ul>
          </div>
        </div>
        <div class="introduce-board">
          <p class="en">RECRUITMENT&nbsp;&nbsp;DIFFICULTIES</p>
          <p class="p1">招聘的辛酸泪&nbsp;&nbsp;&nbsp;&nbsp;猎上网都知道</p>
          <p class="p2">8大难题</p>
        </div>
        <div class="introduce-buy">
          <p class="p1">申请购买可以点击下方链接</p>
          <p class="p2">客户经理会第一时间与您取得联系</p>
          <a href="javascript://" @click="unloginBuyServicePop = true">购买供应商管理</a>
        </div>
        <unlogin-buy-service-success :service-user="serviceUser" v-if="unloginBuyServiceSuccessPop" v-model="unloginBuyServiceSuccessPop"></unlogin-buy-service-success>
        <unlogin-buy-service tit="购买供应商管理" desc="buy-vms" code="intentionSupplier" v-if="unloginBuyServicePop" @openServiceSuccess="openServiceSuccess" v-model="unloginBuyServicePop"></unlogin-buy-service>
    </div>
</template>
<script>
import unloginBuyService from "@/components/unloginBuyService";
import unloginBuyServiceSuccess from "@/components/unloginBuyServiceSuccess";
import DB from "@/common/db";
export default {
  name: "vms-introduce",
  data() {
    return {
      unloginBuyServicePop: false,
      unloginBuyServiceSuccessPop: false,
      serviceUser: {}
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      DB.request({
        url: DB.prefix + "auth/v2/link",
        type: "get",
        success: res => {
          if (res.data && res.data.isLogin) {
            window.location.href = "/vms.html#/list";
          }
        },
        complete: () => {}
      });
    });
  },
  methods: {
    openServiceSuccess(serviceUser) {
      this.serviceUser = serviceUser;
      this.unloginBuyServiceSuccessPop = true;
    }
  },
  components: {
    unloginBuyService,
    unloginBuyServiceSuccess
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.page-vms-introduce {
  width: 100%;
  background: #fff;
  background-size: 100%;
  height: 100%;
  .introduce-main-box {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  .introduce-top-bg {
    position: relative;
    width: 100%;
  }
  .introduce-top-wrap {
    height: 500px;
    background: #1abe6b;
    background: rgba(26, 190, 107, 0.8);
    background-size: 100%;
    filter: Alpha(opacity=.8);
    *zoom: 1;
    color: #fff;
    position: relative;
    z-index: 11;
    .top-tit {
      padding-top: 110px;
      color: #fff;
      width: 100%;
      h2 {
        font-size: 48px;
        line-height: 68px;
      }
      p {
        font-size: 24px;
        line-height: 40px;
      }
      .txt2 {
        font-size: 16px;
        strong {
          margin-left: 5px;
        }
      }
      a {
        border-radius: 42px;
        font-size: 18px;
        line-height: 45px;
        display: inline-block;
        height: 45px;
        color: #1abe6b;
        width: 188px;
        margin-top: 50px;
        background: #fff;
        text-align: center;
      }
    }
    .top-mac {
      position: absolute;
      width: 690px;
      height: 468px;
      background: url("../../assets/introduce/mac2.png") no-repeat left 0;
      background-size: 100%;
      right: 0;
      top: 170px;
    }
  }
  .introduce-top-wrap-bg {
    height: 500px;
    background: url("../../assets/introduce/bg.jpg") no-repeat 0 -330px;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 10;
  }
  .introduce-core {
    padding-left: 620px;
    height: 478px;
    margin-top: 155px;
    background: url("../../assets/introduce/service-big-2.png") no-repeat 135px
      top;
    h3 {
      font-size: 36px;
      line-height: 50px;
      strong {
        color: #2d8cf0;
        font-weight: normal;
      }
    }
    ul {
      margin-top: 24px;
    }
    li {
      margin-top: 20px;
      height: 36px;
      line-height: 36px;
      color: #393a41;
      font-size: 20px;
      line-height: 28px;
      span {
        display: inline-block;
        width: 36px;
        height: 36px;
        line-height: 36px;
        background: #2d8cf0;
        border-radius: 50%;
        font-size: 18px;
        color: #fff;
        text-align: center;
        margin-right: 20px;
      }
    }
  }
  .introduce-board {
    width: 100%;
    text-align: center;
    height: 778px;
    padding-top: 50px;
    background: #fff url("../../assets/introduce/blackboard.jpg") no-repeat
      center center;
    .en {
      font-size: 14px;
      line-height: 20px;
      color: #2d8cf0;
      font-family: PingFangSC-Semibold;
    }
    .p1 {
      color: #fff;
      font-size: 36px;
      line-height: 50px;
      margin-top: 5px;
    }
    .p2 {
      color: #fff;
      font-weight: bold;
      font-size: 72px;
      line-height: 100px;
    }
  }
  .introduce-buy {
    width: 100%;
    height: 250px;
    background: #fff url("../../assets/introduce/footer.jpg") no-repeat center
      center;
    text-align: center;
    color: #fff;
    padding-top: 45px;
    .p1 {
      font-size: 36px;
      line-height: 50px;
    }
    .p2 {
      font-size: 20px;
      line-height: 28px;
      margin-top: 4px;
    }
    a {
      border-radius: 42px;
      font-size: 18px;
      line-height: 45px;
      display: inline-block;
      height: 45px;
      color: #2d8cf0;
      width: 188px;
      margin-top: 30px;
      background: #fff;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/unloginIntroduce/vmsIntroduce.vue